import { render, staticRenderFns } from "./UploadMedia.vue?vue&type=template&id=63826515&"
import script from "./UploadMedia.vue?vue&type=script&lang=js&"
export * from "./UploadMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports